import { useEffect } from 'react';
import type { HotjarProps } from './types.js';

const Hotjar = (props: HotjarProps) => {
    const { canUseHotjar } = props;

    useEffect(() => {
        if (!canUseHotjar) return;

        // Check if already injected to prevent duplicate scripts
        if (document.getElementById('hotjar-script')) return;

        // Hotjar Tracking Code for Torget (TJT)
        const script = document.createElement('script');
        script.id = 'hotjar-script';
        script.innerHTML = `
            (function(h,o,t,j,a,r){
                h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                h._hjSettings={hjid:1666135,hjsv:6};
                a=o.getElementsByTagName('head')[0];
                r=o.createElement('script');r.async=1;
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `;
        document.head.appendChild(script);
    }, [canUseHotjar]);

    return null;
};

export default Hotjar;
